export default __webpack_public_path__ + "static/pulse-d8175b7fd5da089c9083ab73ad4e3e6b.png";